import type { FaireProductEntity } from "../../entity_types/product";

export const p_zwf5bbtdsv: FaireProductEntity = {
  token: "p_zwf5bbtdsv",
  type: "product",
  name: "Shower Steamers",
  brandName: "Stoney River Soaps",
  imageUrl:
    "https://cdn.faire.com/fastly/22910c700e2e8e77386d024ba40c000b669e87197733d41e2dbef8b85281236e.jpeg",
  priceDollars: 1.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/8ae65b7c1b1101e291e4338698ae4259a96c687a9a1fc5fa15c8b18fa25540f8.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
